import { type Carrier } from '../domain/Shipment'

function defaultValue(value: string | number | undefined) {
  return value ?? '-'
}

export function formatCarrierInfo(carrier: Pick<Carrier, 'dot' | 'mc' | 'scac' | 'email'>): string {
  const carrierData = [
    `MC ${defaultValue(carrier.mc)}`,
    `DOT ${defaultValue(carrier.dot)}`,
    `SCAC ${defaultValue(carrier.scac)}`,
    carrier.email,
  ]

  return carrierData.join(' • ')
}
